import React, { useState, useRef, useEffect } from 'react';
import { format } from 'date-fns';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { Calendar } from './Calendar';
import { cn } from './Calendar';

const DateRangePicker = ({
  dateRange,
  onDateRangeChange,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={cn("relative", className)} ref={containerRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "w-full px-4 py-3 bg-white border rounded-2xl flex items-center gap-3 transition-all outline-none focus:ring-4 focus:ring-indigo-500/5",
          isOpen ? "border-[#18216D] shadow-md" : "border-slate-200 hover:border-[#18216D]/30",
          !dateRange?.from && !dateRange?.to && "text-slate-400"
        )}
      >
        <CalendarIcon className="w-5 h-5 flex-shrink-0" />
        <span className="text-sm font-bold truncate">
          {dateRange?.from ? (
            dateRange.to ? (
              <>
                {format(dateRange.from, "LLL dd, y")} -{" "}
                {format(dateRange.to, "LLL dd, y")}
              </>
            ) : (
              format(dateRange.from, "LLL dd, y")
            )
          ) : (
            <span className="font-bold text-[10px] uppercase tracking-wider text-slate-400">Filter by date</span>
          )}
        </span>
      </button>

      {isOpen && (
        <div className="absolute z-[100] top-full mt-2 left-0 bg-white border border-slate-100 shadow-2xl rounded-2xl p-2 animate-in fade-in zoom-in-95 duration-200">
          <Calendar
            mode="range"
            selected={dateRange}
            defaultMonth={dateRange?.from}
            onSelect={onDateRangeChange}
            numberOfMonths={1}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
